import { render, staticRenderFns } from "./admin-sample.vue?vue&type=template&id=3240360e&scoped=true&"
import script from "./admin-sample.vue?vue&type=script&lang=ts&"
export * from "./admin-sample.vue?vue&type=script&lang=ts&"
import style0 from "./admin-sample.vue?vue&type=style&index=0&id=3240360e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3240360e",
  null
  
)

export default component.exports